import { useAuth } from '../../auth/AuthContext.jsx';

export default function Profile() {
  const { customer } = useAuth();

  if (!customer) return null;

  return (
    <div className="container" style={{ paddingTop: 'var(--space-6)', paddingBottom: 'var(--space-8)', maxWidth: 600, margin: '0 auto' }}>
      <h1 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 700, marginBottom: 'var(--space-3)' }}>
        Mon profil
      </h1>

      <div className="card" style={{ padding: 'var(--space-4)' }}>
        <div style={{ display: 'grid', gap: 'var(--space-3)' }}>
          <ProfileField label="Prénom" value={customer.firstName} />
          <ProfileField label="Nom" value={customer.lastName} />
          <ProfileField label="Email" value={customer.email} />
          <ProfileField label="Téléphone" value={customer.phone || 'Non renseigné'} />
        </div>
      </div>

      <p style={{ marginTop: 'var(--space-2)', fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)', textAlign: 'center' }}>
        La modification du profil sera bientôt disponible.
      </p>
    </div>
  );
}

function ProfileField({ label, value }) {
  return (
    <div>
      <div style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-muted)', marginBottom: 4 }}>
        {label}
      </div>
      <div style={{ fontSize: 'var(--font-size-base)', fontWeight: 500 }}>
        {value}
      </div>
    </div>
  );
}
